module.exports = __webpack_public_path__ + "static/18-860db30414bc3eb720a134c1bae80ab6.png";